<template>
  <PageWrapper>
    <template v-slot:content>
      <el-form ref="formRef" :model="form" class="company-info_form" label-width="120px"
               :label-position="getIsMobile?'top':'right'">
        <el-form-item label="系统名称" prop="xname">
          <el-input placeholder="请输入系统名称" v-model="form.xname" />
        </el-form-item>
        <el-form-item label="公司全称" prop="cname">
          <el-input placeholder="请输入公司全称" v-model="form.cname" />
        </el-form-item>
        <el-form-item label="英文全称" prop="uname">
          <el-input placeholder="请输入英文全称" v-model="form.uname" />
        </el-form-item>
        <el-form-item label="公司网址" prop="wangzhi">
          <el-input placeholder="请输入公司网址" v-model="form.wangzhi" />
        </el-form-item>
        <el-form-item label="发票类型" prop="wangzhi">
          <el-input placeholder="请输入发票类型" v-model="form.fplx" />
        </el-form-item>
        <el-form-item label="logo" prop="logo" >
          <Upload :fileList="form.logo" @uploadChange="val => form.logo = val" />
        </el-form-item>
        <el-form-item label="合同章" prop="contract_chapter">
          <Upload :fileList="form.contract_chapter" @uploadChange="val => form.contract_chapter = val" />
        </el-form-item>
        <el-form-item label="报价单章" prop="quotation_contract">
          <Upload :fileList="form.quotation_contract" @uploadChange="val => form.quotation_contract = val" />
        </el-form-item>
        <el-form-item label="报价单编号" prop="bjdbh">
          <el-input placeholder="请输入报价单编号" v-model="form.bjdbh"><span slot="append">如: JZCY</span></el-input>
        </el-form-item>
        <el-form-item label="合同编号" prop="htbh">
          <el-input placeholder="请输入合同编号" v-model="form.htbh"><span slot="append">如: JZCY</span></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input placeholder="请输入公司地址" v-model="form.address" />
        </el-form-item>
        <el-form-item label="400热线" prop="sill">
          <el-input placeholder="请输入400热线" v-model="form.sill" />
        </el-form-item>
        <el-form-item label="座机" prop="mobile">
          <el-input placeholder="请输入座机" v-model="form.mobile" />
        </el-form-item>
        <el-form-item label="企业QQ" prop="qyqq">
          <el-input placeholder="请输入企业QQ" v-model="form.qyqq" />
        </el-form-item>
        <el-form-item label="E-mail" prop="email">
          <el-input placeholder="请输入E-mail" v-model="form.email" />
        </el-form-item>
        <el-form-item label="传真" prop="max">
          <el-input placeholder="请输入传真" v-model="form.max" />
        </el-form-item>
        <el-form-item label="税号" prop="shuihao">
          <el-input placeholder="请输入税号" v-model="form.shuihao" />
        </el-form-item>
        <el-form-item label="开户银行" prop="bank">
          <el-input placeholder="请输入开户银行" v-model="form.bank" />
        </el-form-item>
        <el-form-item label="银行帐号" prop="banknum">
          <el-input placeholder="请输入银行帐号" v-model="form.banknum" />
        </el-form-item>
        <el-form-item label="发货人" prop="fhmember">
          <el-input placeholder="请输入发货人" v-model="form.fhmember" />
        </el-form-item>
        <el-form-item label="发货备注" prop="fhbz">
          <el-input placeholder="请输入发货备注" v-model="form.fhbz" />
        </el-form-item>
        <el-form-item label="报价单摘要" prop="bjdzy" class="editor">
          <div ref="summaryEditor" class="summaryEditor"></div>
        </el-form-item>
        <el-form-item label="报价单条款" prop="bjdtk" class="editor">
          <div ref="termEditor" class="termEditor"></div>
        </el-form-item>
        <el-form-item label="合同条款" prop="content" class="editor">
          <div ref="contractEditor" class="contractEditor"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleReset">重 置</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </template>
  </PageWrapper>
</template>
<script>
import { defineComponent, onMounted, reactive, ref, nextTick, getCurrentInstance } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import useRootSetting from '@/hooks/useRootSetting'
import E from 'wangeditor'
import Upload from './Upload.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'


export default defineComponent({
  name: 'CompanyInfo',
  components: { PageWrapper, Upload },
  setup() {
    const { getIsMobile } = useRootSetting()
    const formRef = ref(null)
    const { proxy } = getCurrentInstance()
    const store = proxy.$store // ✅ 手动取
    const defaultForm = () => ({
      xname: '',
      cname: '',
      uname: '',
      wangzhi: '',
      fplx: '',
      bjdbh: '',
      htbh: '',
      address: '',
      sill: '',
      mobile: '',
      qyqq: '',
      email: '',
      max: '',
      shuihao: '',
      bank: '',
      banknum: '',
      fhmember: '',
      fhbz: '',
      bjdzy: '',
      bjdtk: '',
      content: '',
      logo: [{ name: '', url: '' }],
      contract_chapter: [{ name: '', url: '' }],
      quotation_contract: [{ name: '', url: '' }]
    })
    const form = reactive(defaultForm())
    const formData = reactive({
      policy: '',
      OSSAccessKeyId: '',
      success_action_status: '200',
      signature: ''
    })

    const contentList = ref([])
    const summaryEditor = ref(null)
    const termEditor = ref(null)
    const contractEditor = ref(null)


    onMounted(async () => {
      await nextTick()
      summaryEditor.value = new E(summaryEditor.value) // 报价单摘要
      termEditor.value = new E(termEditor.value) //报价单条款
      contractEditor.value = new E(contractEditor.value) //合同条款
      await Promise.all([
        new Promise((resolve) => {
          summaryEditor.value.create()
          nextTick(() => {
            summaryEditor.value.config.zIndex = 1000
          })
          summaryEditor.value.config.onchange = (newHtml) => {
            form.bjdzy = newHtml
          }
          resolve()
        }),
        new Promise((resolve) => {
          termEditor.value.create()
          nextTick(() => {
            termEditor.value.config.zIndex = 1000
          })
          termEditor.value.config.onchange = (newHtml) => {
            form.bjdtk = newHtml
          }
          resolve()
        }),
        new Promise((resolve) => {
          contractEditor.value.create()
          nextTick(() => {
            contractEditor.value.config.zIndex = 1000
          })
          contractEditor.value.config.onchange = (newHtml) => {
            form.content = newHtml
          }
          resolve()
        })
      ])
      getCompanyInfo()
    })

    const getCompanyInfo = () => {
      request({
        url: 'company_info_list.yy',
        method: 'post'
      }).then(res => {
        if (res.code == 200) {
          Object.assign(form, res.data[0])
          if( summaryEditor.value.txt &&   termEditor.value.txt &&  contractEditor.value.txt) {
            summaryEditor.value.txt.html(res.data[0].bjdzy)
            termEditor.value.txt.html(res.data[0].bjdtk)
            contractEditor.value.txt.html(res.data[0].content)
          }
          form.logo = Array.isArray(res.data[0].logo)
            ? res.data[0].contract_chapter
            : [{ name: 'logo', url: res.data[0].logo }]

          form.contract_chapter = Array.isArray(res.data[0].contract_chapter)
            ? res.data[0].contract_chapter
            : [{ name: '合同章', url: res.data[0].contract_chapter }]

          form.quotation_contract = Array.isArray(res.data[0].quotation_contract)
            ? res.data[0].quotation_contract
            : [{ name: '报价单章', url: res.data[0].quotation_contract }]

        }
      })
    }

    const handleReset = () => {
      Object.assign(form, defaultForm())
    }

    const handleSubmit = () => {
      form.logo = Array.isArray(form.logo)
        ? form.logo
        : [{ name: 'logo', url: form.logo }]

      form.contract_chapter = Array.isArray(form.contract_chapter)
        ? form.contract_chapter
        : [{ name: '合同章', url: form.contract_chapter }]

      form.quotation_contract = Array.isArray(form.quotation_contract)
        ? form.quotation_contract
        : [{ name: '报价单章', url: form.quotation_contract }]
      Object.assign(form, {
        logo: form.logo,
        contract_chapter: form.contract_chapter,
        quotation_contract: form.contract_chapter
      })
      request({
        url: 'company_info_update.yy',
        method: 'post',
        data: form
      }).then(res => {
        if (res.code == 200) {
          Message.success(res.msg)
          getCompanyInfo()
          store.dispatch('user/getInfo')
        }
      })
    }
    return {
      store,
      summaryEditor,
      termEditor,
      contractEditor,
      getIsMobile,
      formRef,
      form,
      contentList,
      formData,
      // getLogo,
      // getContractChapter,
      // getQuotationContract,
      handleReset,
      handleSubmit
    }
  }
})
</script>

<style scoped lang="scss">

.company-info_form {
  padding: 30px 60px 60px 20px
}

.dialog-footer {
  position: absolute;
  right: 20px;
  bottom: 20px;
}

.editor {
  margin-bottom: 20px;

  .summaryEditor, .termEditor, .contractEditor {
    z-index: 1 !important;
    position: relative;
  }
}
</style>
